import { parseJwt } from 'cu-master-layout-prop-manager';

export const injectAhaWidget = (token: string) => {
  const tokenData = parseJwt(token);

  const script = document.createElement('script');

  script.innerHTML = `
    (function(w, d, s, o, f, js, fjs) {
      w['aha-widget'] = o;
      w[o] = w[o] || function() {
        (w[o].q = w[o].q || []).push(arguments);
      };
      js = d.createElement(s);
      fjs = d.getElementsByTagName(s)[0];
      js.id = o;
      js.src = f;
      js.async = 1;
      fjs.parentNode.insertBefore(js, fjs);
    })(window, document, 'script', 'aha', 'https://cdn.aha.io/assets/feedback/feedback.js');

    aha('initialize', {
      account: 'cu-collaborate',
      applicationId: '7226008012719965514',
      user: {
        id: "${tokenData['userId']}",
        name: "${tokenData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name']}",
        email: "${tokenData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress']}",
      },
    });
  `;

  document.body.appendChild(script);

  if (window.aha) {
    window.aha('open', import.meta.env.VITE_AHA_WIDGET_ID);
  } else {
    console.error('Aha! widget script is not loaded yet.');
  }
};
